import React from "react";
import SEO from "components/SEO/SEO";
import "./Careers.css";

const ROLES = [
  { title: "Field Recovery Executive", type: "Full-time", location: "Bangalore, Karnataka" },
  { title: "Telecalling Agent", type: "Full-time", location: "Bangalore, Karnataka" },
  { title: "Team Leader — Collections", type: "Full-time", location: "Bangalore, Karnataka" },
  { title: "MIS & Reporting Analyst", type: "Full-time", location: "Bangalore, Karnataka" },
];

export default function Careers() {
  return (
    <>
      <SEO
        title="Careers at CSR Associates | Jobs in Debt Recovery & BPO Bangalore"
        description="Join CSR Associates — Bangalore's leading debt recovery and BPO company. Open positions in field collections, telecalling, team leadership and analytics."
        keywords="careers CSR Associates, jobs debt recovery bangalore, BPO jobs karnataka"
      />
      <div className="careers-page">
        <div className="container" style={{ maxWidth: 1200, margin: "0 auto", padding: "80px 24px" }}>

          <div className="page-hero" data-aos="fade-up">
            <span className="page-hero-tag">Careers</span>
            <h1 className="page-hero-title">
              Grow With <em>Purpose</em>
            </h1>
            <p className="page-hero-sub">
              Join a team that values ethics, performance, and professional growth.
              Make a real impact in India's financial services sector.
            </p>
            <div className="page-hero-divider" />
          </div>

          {/* Culture */}
          <div className="careers-culture" data-aos="fade-up">
            <div className="eyebrow">Why CSR</div>
            <h2 className="section-heading" style={{ marginBottom: "36px" }}>
              A Culture of <span className="accent">Excellence</span>
            </h2>
            <div className="culture-grid">
              {[
                ["🌱", "Real Growth", "Clear career paths from executive to team leader to operations management."],
                ["⚖️", "Ethical Workplace", "RBI-compliant operations with zero tolerance for coercion or harassment."],
                ["📚", "Continuous Learning", "Regular training, compliance updates, and professional development."],
                ["🤝", "Team Culture", "Collaborative, supportive environment where every contribution is valued."],
              ].map(([icon, title, desc], i) => (
                <div key={i} className="culture-card" data-aos="fade-up" data-aos-delay={i * 80}>
                  <span className="culture-icon">{icon}</span>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Open Roles */}
          <div className="open-roles" data-aos="fade-up">
            <div className="eyebrow">Open Positions</div>
            <h2 className="section-heading" style={{ marginBottom: "28px" }}>
              Current <span className="accent">Openings</span>
            </h2>
            {ROLES.map((role, i) => (
              <div key={i} className="role-card" data-aos="fade-right" data-aos-delay={i * 60}>
                <div className="role-info">
                  <div className="role-title">{role.title}</div>
                  <div className="role-meta">
                    <span>{role.type}</span>
                    <span>📍 {role.location}</span>
                  </div>
                </div>
                <a
                  href={`mailto:hr@csrassociates.co?subject=Application — ${role.title}`}
                  className="btn-outline-gold"
                  style={{ flexShrink: 0 }}
                >
                  Apply Now
                </a>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="careers-cta" data-aos="zoom-in">
            <h2>Don't See a Matching Role?</h2>
            <p>Send us your resume and we'll reach out when the right opportunity arises.</p>
            <a href="mailto:hr@csrassociates.co?subject=General%20Application" className="btn-gold">
              Send Your Resume
            </a>
          </div>

        </div>
      </div>
    </>
  );
}
